/**
 * Section ids for the /features hub page and the Product-menu items that
 * link to them. The header, footer and page all import from here so the
 * anchors cannot drift apart.
 */

export const FEATURE_SECTION_IDS = [
  "prompts",
  "scans",
  "visibility",
  "answers",
  "competitors",
  "sources",
  "content",
  "integrations",
] as const;

export type FeatureSectionId = (typeof FEATURE_SECTION_IDS)[number];

export const FEATURES_PATH = "/features";

export const MARKETING_FEATURE_NAV_ITEMS: ReadonlyArray<{
  href: `/features#${FeatureSectionId}`;
  name: string;
  description: string;
}> = [
  {
    href: "/features#prompts",
    name: "Prompt discovery",
    description: "Find the questions buyers ask AI about your category",
  },
  {
    href: "/features#visibility",
    name: "Brand visibility",
    description: "How often you appear, per engine, over time",
  },
  {
    href: "/features#answers",
    name: "Answer transcripts",
    description: "Read exactly what each engine says about your brand",
  },
  {
    href: "/features#competitors",
    name: "Competitors and share of voice",
    description: "Who wins each question, and by how much",
  },
  {
    href: "/features#sources",
    name: "Sources and citations",
    description: "Which pages AI engines trust in your space",
  },
  {
    href: "/features#content",
    name: "Content and pages",
    description: "Which of your pages do the work",
  },
];

/**
 * Returns the section id for a `/features#<id>` href, or null when the href
 * is not a features section link.
 */
export function anchorOf(href: string): FeatureSectionId | null {
  const prefix = `${FEATURES_PATH}#`;
  if (!href.startsWith(prefix)) return null;
  const id = href.slice(prefix.length);
  return (FEATURE_SECTION_IDS as readonly string[]).includes(id)
    ? (id as FeatureSectionId)
    : null;
}
